/* eslint-disable import/no-anonymous-default-export */
import { config } from '../../utils/config';
import shippingActions from '../../store/shippingActions';
import { Address } from '../../enums/checkoutShipping';
import shippingUtils from '../../utils/shipping';
import { get } from '../storage/localStorage';
import { Page } from '../../enums/page';
import { get as getCookie } from '../cookies';
import { getCountryCallingCode, isValidNumberForRegion } from 'libphonenumber-js';


declare const window: any;

const emailIdChangeAndBlur = ({ event, dispatch, value, isBrowserAutoFill }) => {
    if((event?.type === 'change' && isBrowserAutoFill) || event?.type === 'blur') {
        dispatch(shippingActions.setIsValidEmail('true'));
        dispatch(shippingActions.getEmailValidated(value));
    }
    dispatch(shippingActions.checkIsEmailChanged({isEmailChanged: true}));
}
const postalCodeBlur = ({ dispatch }) => {
    dispatch(shippingActions.setIsPostalCodeBlur(true))
}
const phoneNumberClick = ({event}) => {
    let phoneFieldVal = event.target.value;
    phoneFieldVal = phoneFieldVal.replace(/[^\d]/g, '');
    if(phoneFieldVal.length === 0 && event?.target?.setSelectionRange) {
        event.target.setSelectionRange(1,1);
    }
}
const phoneNumberChange = ({ type, setAddressFormCall }) => {
    // const addressType = type === Address.SHIPPING_ADDRESS ?'shippingAddress' : 'billingAddress';
    // setAddressFormCall((prevState) => {
    //     return {
    //         ...prevState,
    //         [addressType]: {
    //             ...prevState[addressType],
    //             phone: {
    //                 ...prevState[addressType].phone,
    //                 showMsg : false
    //             }
    //         }
    //     }
    // });
}
const phoneNumberBlur = ({ type, value, state, setAddressFormCall }) => {
    const isPCC = getCookie('np.pcc');
    const { shippingState: { address: { currentSelectedCountry } } } = state;
    if (config('isNASite')) {
        if(value?.replace(/[^\d]/g, "")?.length !== 10) {
            setAddressFormCall({
                type, modifyStateCallback: (prevState) => {
                    return {
                        phone: {
                            ...prevState[type].phone,
                            value: isPCC ? value : "",
                        }
                    }
                }
            });
        }
        return;
    }
    let telPrefix = getCountryCallingCode(currentSelectedCountry);
    let phoneNumber = telPrefix + value;
    let isValidNumber = isValidNumberForRegion('+'+phoneNumber, currentSelectedCountry.toUpperCase());
    if (!isValidNumber && value.trim()) {
        setAddressFormCall({
            type, modifyStateCallback: (prevState) => {
                return {
                    phone: {
                        ...prevState[type].phone,
                        showMsg: true
                    }
                }
            }
        });
    }
}

const postalCodeChange = ({ dispatch, value, setAddressFormCall, type }) => {
    let fieldVal = value;
    if (config('isNASite')) {
        if (config('regionCode') === 'US') {
            fieldVal = fieldVal.replace(/-/g, ''); // remove all occurrences of '-'
            fieldVal = fieldVal.length > 5 ? fieldVal.substring(0, 5) + '-' + fieldVal.substring(5) : fieldVal;
        } else if (config('regionCode') === 'CA') {
            fieldVal = fieldVal.replace(/ /g, '');
            if (fieldVal.length > 3) {
                fieldVal = fieldVal.substr(0, 3) + ' ' + fieldVal.substr(3); // Add space after 3 characters/digits
            }
        }
        setAddressFormCall({
            type, modifyStateCallback: (prevState) => {
                return {
                    postalCode: {
                        ...prevState[type].postalCode,
                        value: fieldVal
                    }
                }
            }
        });
    }
    dispatch(shippingActions.setIsPostalCodeBlur(false))
}

const countryChange = ({ dispatch, event, value, state, addressForm, setAddressFormCall }) => {
    const {
        applicationState: { user }, customerState : { customer : { vatId }}
    } = state;

    const guestAddress: any = get('cartAddress');
    const isCartAddressPresent = user.isLoggedIn === 'false' && guestAddress && guestAddress?.shipping?.country === value;
    let defaultAddress = "";
    if(value === '') {
        value = config('regionCode');
    }
    let mode = Address.NEW_FORM;
    if(event.target.id === 'edit-delivery-address-country') {
        mode = Address.EDIT_FORM;
    }

    if(isCartAddressPresent) {
        defaultAddress = guestAddress?.shipping;
    }

    let getNewFormFields = shippingUtils.getAddressFieldProps({ type: Address.SHIPPING_ADDRESS, mode: mode, defaultAddress: defaultAddress, regionCode: value, isLoggedIn:user.isLoggedIn });

    if(!isCartAddressPresent) {
        getNewFormFields = shippingUtils.retriveOldData(addressForm.shippingAddress, getNewFormFields);
    }

    dispatch(shippingActions.setVatStatus(''));
    dispatch(shippingActions.setOldVatId(''));
    dispatch(shippingActions.setOldVatCountry(''));
    
    if(config('VAT_ENABLED_COUNTRY').includes(value) && vatId.includes(value)) {
        getNewFormFields.vatId.value = vatId;
    }
    else {
        getNewFormFields.vatId.value = "";
    }

    setAddressFormCall({
        type: Address.SHIPPING_ADDRESS, modifyStateCallback: () => {
            return { ...getNewFormFields}
        }, updateTypeSpecificState: true
    });

    if (isCartAddressPresent && !guestAddress.shipping.billingAddressAgreement && guestAddress?.billing?.country?.value === config('regionCode')) {
        let billingFormFields = shippingUtils.getAddressFieldProps({ type: Address.BILLING_ADDRESS, mode: mode, defaultAddress: guestAddress?.billing || "", regionCode: config('regionCode'), isLoggedIn: user.isLoggedIn });
        setAddressFormCall({
            type: Address.BILLING_ADDRESS, modifyStateCallback: () => {
                return { ...billingFormFields }
            }, updateTypeSpecificState: true
        });
    }

}

const addressLine2OnChange = ({value, type, state, setAddressFormCall}) => {
    const {
        applicationState : {currentPage}
    } = state;
    if (config('regionCode') === 'US' && currentPage !== Page.MYACCOUNT) {
        shippingUtils.showHidePOBoxWarning({value, addressLine:'addressLine2', type, setAddressFormCall});
    }
}
export {
    emailIdChangeAndBlur,
    postalCodeChange,
    phoneNumberClick,
    phoneNumberChange,
    phoneNumberBlur,
    countryChange,
    postalCodeBlur,
    addressLine2OnChange
}